// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActionTextCharacterLimiterController from "./action_text_character_limiter_controller"
application.register("action-text-character-limiter", ActionTextCharacterLimiterController)

import ActivitiesPikaController from "./activities_pika_controller"
application.register("activities-pika", ActivitiesPikaController)

import AdvSearchController from "./adv_search_controller"
application.register("adv-search", AdvSearchController)

import AftOccController from "./aft_occ_controller"
application.register("aft-occ", AftOccController)

import AlertsController from "./alerts_controller"
application.register("alerts", AlertsController)

import AlertsToggleController from "./alerts_toggle_controller"
application.register("alerts-toggle", AlertsToggleController)

import AmountAmendController from "./amount_amend_controller"
application.register("amount-amend", AmountAmendController)

import AssetGridController from "./asset_grid_controller"
application.register("asset-grid", AssetGridController)

import AttdValController from "./attd_val_controller"
application.register("attd-val", AttdValController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AvailabilityAllDayToggleController from "./availability_all_day_toggle_controller"
application.register("availability-all-day-toggle", AvailabilityAllDayToggleController)

import BannerImgController from "./banner_img_controller"
application.register("banner-img", BannerImgController)

import BillingAddressFormController from "./billing_address_form_controller"
application.register("billing-address-form", BillingAddressFormController)

import BlockedDeleteController from "./blocked_delete_controller"
application.register("blocked-delete", BlockedDeleteController)

import BookingButtonEnablerController from "./booking_button_enabler_controller"
application.register("booking-button-enabler", BookingButtonEnablerController)

import BoroughReloadController from "./borough_reload_controller"
application.register("borough-reload", BoroughReloadController)

import BookingFormController from "./booking_form_controller"
application.register("booking-form", BookingFormController)

import BookingFormSectionController from "./booking_form_section_controller"
application.register("booking-form-section", BookingFormSectionController)

import BookingFormSubmitButtonController from "./booking_form_submit_button_controller"
application.register("booking-form-submit-button", BookingFormSubmitButtonController)

import BookingFormTimeAndDurationButtonEnablerController from "./booking_form_time_and_duration_button_enabler_controller"
application.register("booking-form-time-and-duration-button-enabler", BookingFormTimeAndDurationButtonEnablerController)

import BookingSummaryController from "./booking_summary_controller"
application.register("booking-summary", BookingSummaryController)

import BookingTypeReasonController from "./booking_type_reason_controller"
application.register("booking-type-reason", BookingTypeReasonController)

import BookingsCalendarController from "./bookings_calendar_controller"
application.register("bookings-calendar", BookingsCalendarController)

import BootstrapModalController from "./bootstrap_modal_controller"
application.register("bootstrap-modal", BootstrapModalController)

import BrowserLocationController from "./browser_location_controller"
application.register("browser-location", BrowserLocationController)

import CallToActionController from "./call_to_action_controller"
application.register("call-to-action", CallToActionController)

import CatGridSwitchController from "./cat_grid_switch_controller"
application.register("cat-grid-switch", CatGridSwitchController)

import ChargesToggleController from "./charges_toggle_controller"
application.register("charges-toggle", ChargesToggleController)

import CheckboxController from "./checkbox_controller"
application.register("checkbox", CheckboxController)

import CheckboxFieldController from "./checkbox_field_controller"
application.register("checkbox-field", CheckboxFieldController)

import Cms__Bookings__BookingReasonToggleController from "./cms/bookings/booking_reason_toggle_controller"
application.register("cms--bookings--booking-reason-toggle", Cms__Bookings__BookingReasonToggleController)

import Cms__OngoingToggleController from "./cms/ongoing_toggle_controller"
application.register("cms--ongoing-toggle", Cms__OngoingToggleController)

import CmsBookingAddDateController from "./cms_booking_add_date_controller"
application.register("cms-booking-add-date", CmsBookingAddDateController)

import CmsBookingFormController from "./cms_booking_form_controller"
application.register("cms-booking-form", CmsBookingFormController)

import CmsBookingRepeatController from "./cms_booking_repeat_controller"
application.register("cms-booking-repeat", CmsBookingRepeatController)

import CmsBookingSpecifiedRepeatSwitcherController from "./cms_booking_specified_repeat_switcher_controller"
application.register("cms-booking-specified-repeat-switcher", CmsBookingSpecifiedRepeatSwitcherController)

import CmsBusinessBookingSwitcherController from "./cms_business_booking_switcher_controller"
application.register("cms-business-booking-switcher", CmsBusinessBookingSwitcherController)

import CmsItemGroupsController from "./cms_item_groups_controller"
application.register("cms-item-groups", CmsItemGroupsController)

import CmsLocationRoleController from "./cms_location_role_controller"
application.register("cms-location-role", CmsLocationRoleController)

import CmsSpinnerController from "./cms_spinner_controller"
application.register("cms-spinner", CmsSpinnerController)

import CmsUserFormController from "./cms_user_form_controller"
application.register("cms-user-form", CmsUserFormController)

import DuraPickController from "./dura_pick_controller"
application.register("dura-pick", DuraPickController)

import DurationPickerController from "./duration_picker_controller"
application.register("duration-picker", DurationPickerController)

import FacetClearController from "./facet_clear_controller"
application.register("facet-clear", FacetClearController)

import FaqsController from "./faqs_controller"
application.register("faqs", FaqsController)

import FilterExpandController from "./filter_expand_controller"
application.register("filter-expand", FilterExpandController)

import FlashNoticeController from "./flash_notice_controller"
application.register("flash-notice", FlashNoticeController)

import HeadexpdController from "./headexpd_controller"
application.register("headexpd", HeadexpdController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HoverSyncController from "./hover_sync_controller"
application.register("hover-sync", HoverSyncController)

import JumpToPageController from "./jump_to_page_controller"
application.register("jump-to-page", JumpToPageController)

import ListmodalController from "./listmodal_controller"
application.register("listmodal", ListmodalController)

import MobSidebarController from "./mob_sidebar_controller"
application.register("mob-sidebar", MobSidebarController)

import MobileBurgerController from "./mobile_burger_controller"
application.register("mobile-burger", MobileBurgerController)

import MobileSearchController from "./mobile_search_controller"
application.register("mobile-search", MobileSearchController)

import NavDropdownController from "./nav_dropdown_controller"
application.register("nav-dropdown", NavDropdownController)

import OpayoPaymentAttemptFormController from "./opayo_payment_attempt_form_controller"
application.register("opayo-payment-attempt-form", OpayoPaymentAttemptFormController)

import OpeningTimesController from "./opening_times_controller"
application.register("opening-times", OpeningTimesController)

import PikadayInitController from "./pikaday_init_controller"
application.register("pikaday-init", PikadayInitController)

import ProgstepsController from "./progsteps_controller"
application.register("progsteps", ProgstepsController)

import ReciteMeController from "./recite_me_controller"
application.register("recite-me", ReciteMeController)

import RegionLondonController from "./region_london_controller"
application.register("region-london", RegionLondonController)

import ResultAvailController from "./result_avail_controller"
application.register("result-avail", ResultAvailController)

import RichTextTableController from "./rich_text_table_controller"
application.register("rich-text-table", RichTextTableController)

import RoomCardClickHandlerController from "./room_card_click_handler_controller"
application.register("room-card-click-handler", RoomCardClickHandlerController)

import SearchFilterController from "./search_filter_controller"
application.register("search-filter", SearchFilterController)

import SelectAllController from "./select_all_controller"
application.register("select-all", SelectAllController)

import SelectButtonDisableController from "./select_button_disable_controller"
application.register("select-button-disable", SelectButtonDisableController)

import SelectColourController from "./select_colour_controller"
application.register("select-colour", SelectColourController)

import SidebarToggleController from "./sidebar_toggle_controller"
application.register("sidebar-toggle", SidebarToggleController)

import SimpleOpenController from "./simple_open_controller"
application.register("simple-open", SimpleOpenController)

import SpaceAttdValController from "./space_attd_val_controller"
application.register("space-attd-val", SpaceAttdValController)

import SpacesBlocksController from "./spaces_blocks_controller"
application.register("spaces-blocks", SpacesBlocksController)

import SpacesBoroIdController from "./spaces_boro_id_controller"
application.register("spaces-boro-id", SpacesBoroIdController)

import SpacesDatePikaController from "./spaces_date_pika_controller"
application.register("spaces-date-pika", SpacesDatePikaController)

import SpacesFinderRedirectController from "./spaces_finder_redirect_controller"
application.register("spaces-finder-redirect", SpacesFinderRedirectController)

import SpacesLoadMoreController from "./spaces_load_more_controller"
application.register("spaces-load-more", SpacesLoadMoreController)

import SpacesSectionToggleController from "./spaces_section_toggle_controller"
application.register("spaces-section-toggle", SpacesSectionToggleController)

import SpacesStartTimeController from "./spaces_start_time_controller"
application.register("spaces-start-time", SpacesStartTimeController)

import SystemAlertsController from "./system_alerts_controller"
application.register("system-alerts", SystemAlertsController)

import TableEditorController from "./table_editor_controller"
application.register("table-editor", TableEditorController)

import TableRefreshController from "./table_refresh_controller"
application.register("table-refresh", TableRefreshController)

import TurboModalController from "./turbo_modal_controller"
application.register("turbo-modal", TurboModalController)

import TurboRescueController from "./turbo_rescue_controller"
application.register("turbo-rescue", TurboRescueController)

import WorkTabsController from "./work_tabs_controller"
application.register("work-tabs", WorkTabsController)

import WorksFormatsController from "./works_formats_controller"
application.register("works-formats", WorksFormatsController)

import YearRangeController from "./year_range_controller"
application.register("year-range", YearRangeController)
